import React,{Component} from 'react';
import {
  Button,
  ButtonGroup
} from 'reactstrap';

import Icon from '../../../shared/components/Icon';

import { ACTIVE_PROFILE } from '../../../config';


const CHOOSE_ENGAGEMENT_TYPE = 'choose',
  THIS_OR_THAT_ENGAGEMENT_TYPE = 'this_or_that',
  RATABLE_ENGAGEMENT_TYPE = 'ratable',
  QA_ENGAGEMENT_TYPE = 'qa',
  PUZZLE_ENGAGEMENT_TYPE = 'puzzle';


class CreateEngagementButtons extends Component {
  constructor(){
    super();

    this.state = {
      chooseColor:'#666',
      thisOrThatColor:'#666',
      ratableColor:'#666',
      qaColor:'#666',
      puzzleColor:'#666'
    }
  }

  render(){
    return (
      <ButtonGroup>
        <Button
          disabled={this.props.disabled}
          className='AddEngagementButton'
          onClick={() => this.props.onClick(PUZZLE_ENGAGEMENT_TYPE)}
          onMouseOver={() => this.setState({puzzleColor:'white'})}
          onMouseOut={() => this.setState({puzzleColor:'#666'})}
        >
          <Icon glyph='puzzle' color={this.state.puzzleColor} />
          <span style={{color:this.state.puzzleColor}}>
            &nbsp;&nbsp;&nbsp;&nbsp;Puzzle&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </Button>
        <Button
          disabled={this.props.disabled}
          className='AddEngagementButton'
          onClick={() => this.props.onClick(CHOOSE_ENGAGEMENT_TYPE)}
          onMouseOver={() => this.setState({chooseColor:'white'})}
          onMouseOut={() => this.setState({chooseColor:'#666'})}
        >
          <Icon glyph='choose' color={this.state.chooseColor} />
          <span style={{color:this.state.chooseColor}}>
            &nbsp;&nbsp;&nbsp;&nbsp;Choice&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </Button>
        <Button
          disabled={this.props.disabled}
          className='AddEngagementButton'
          onClick={() => this.props.onClick(THIS_OR_THAT_ENGAGEMENT_TYPE)}
          onMouseOver={() => this.setState({thisOrThatColor:'white'})}
          onMouseOut={() => this.setState({thisOrThatColor:'#666'})}
        >
          <Icon glyph='this_or_that' color={this.state.thisOrThatColor} />
          <span style={{color:this.state.thisOrThatColor}}>
            This or That
          </span>
        </Button>
        <Button
          disabled={this.props.disabled}
          className='AddEngagementButton'
          onClick={() => this.props.onClick(RATABLE_ENGAGEMENT_TYPE)}
          onMouseOver={() => this.setState({ratableColor:'white'})}
          onMouseOut={() => this.setState({ratableColor:'#666'})}
        >
          <Icon glyph='ratable' color={this.state.ratableColor} />
          <span style={{color:this.state.ratableColor}}>
            &nbsp;&nbsp;&nbsp;&nbsp;Video&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </Button>
        <Button
          disabled={this.props.disabled}
          className='AddEngagementButton'
          onClick={() => this.props.onClick(QA_ENGAGEMENT_TYPE)}
          onMouseOver={() => this.setState({qaColor:'white'})}
          onMouseOut={() => this.setState({qaColor:'#666'})}
        >
          <Icon glyph='qa' color={this.state.qaColor} />
          <span style={{color:this.state.qaColor}}>
            &nbsp;&nbsp;&nbsp;&nbsp;Trivia&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </Button>
      </ButtonGroup>
    )
  }
}

export default CreateEngagementButtons;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/CreateEngagementButtons.js